import React, { useContext } from "react";
import { Modal, TouchableOpacity } from "react-native";
import { PurchaserContext, PurchaserInterface } from "../../src/context/PurchaserContext";

const MiscellaneousModal = ({
  modalVisibility,
  onClose,
  disabled = false,
}: {
  modalVisibility: boolean;
  onClose: any;
  disabled?: boolean;
}) => {
  const { state, setMiscModal } = useContext<PurchaserInterface>(PurchaserContext);

  return (
    <Modal visible={modalVisibility} transparent animationType="fade" onRequestClose={onClose}>
      <TouchableOpacity
        style={{ cursor: "", position: "absolute", top: 0, left: 0, right: 0, bottom: 0, borderWidth: 0 }}
        disabled={disabled}
        onPress={() => setMiscModal(false, { x: -1, y: -1 }, null)}
        activeOpacity={1}
      >
        {state.miscModal?.children ? <state.miscModal.children coords={state.miscModal.coords} /> : null}
      </TouchableOpacity>
    </Modal>
  );
};

export default MiscellaneousModal;
